import Shopify from '../utils/Shopify'
import { getProductBySlug, getPage } from '../../content.js'

const shopify = new Shopify()

export default
{
    data()
    {
        return {
            list: [],
            count: 0,
            total: 0,
            checkoutPath: null,
            productsPage: getPage('products').path
        }
    },

    mounted()
    {
        shopify.onCartUpdated.add(this.updateCart)
        shopify.getCart(this.updateCart)
        window.document.body.classList.add('is-cart-open')
    },

    destroyed()
    {
        shopify.onCartUpdated.remove(this.updateCart)
        window.document.body.classList.remove('is-cart-open')
    },

    methods:
    {
        closeCart()
        {
            this.eventHub.$emit('cart:close')
        },

        updateCart(cart)
        {
            const list = []
            // let total = 0
            cart.list.forEach(item =>
            {
                const product = Object.assign({
                    quantity: item.quantity,
                    variants: item.variants
                }, getProductBySlug(item.slug))

                list.push(product)
                // total += item.quantity * Number(product.price.substr(1))
            })

            this.total = cart.totalPrice
            this.count = cart.list.reduce((total, { quantity }) => total + quantity, 0)
            this.list = JSON.parse(JSON.stringify(list))
            this.checkoutPath = cart.webUrl
        },

        removeAll(itemSlug)
        {
            shopify.getProductBySlug(itemSlug, product =>
            {
                const variantId = product.variants[0].id
                shopify.removeItemToCart(variantId)
            })
        },

        add(quantity, itemSlug, oldQuantity = null)
        {
            shopify.getProductBySlug(itemSlug, product =>
            {
                const variantId = product.variants[0].id
                if (quantity > 0)
                {
                    shopify.addItemsToCart(variantId, quantity)
                }
                else
                {
                    shopify.updateItemToCart(variantId, oldQuantity + quantity)
                }
            })
        }
    }
}